import React from 'react';

/** Serve marker for the scoring pad — reads as "this side/player is serving" without a legend. */
export const TennisBall: React.FC<{ className?: string }> = ({ className = 'w-3 h-3' }) => (
  <svg viewBox="0 0 24 24" className={`flex-shrink-0 ${className}`} aria-hidden>
    <circle cx="12" cy="12" r="11" fill="#D4E157" stroke="#9DAA22" strokeWidth="1" />
    <path d="M4.5 4.5C9 9 9 15 4.5 19.5M19.5 4.5C15 9 15 15 19.5 19.5" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

/** Small tennis-net glyph for the doubles "At net" line. */
export const NetIcon: React.FC<{ className?: string }> = ({ className = 'w-5 h-3.5' }) => (
  <svg viewBox="0 0 20 14" className={`flex-shrink-0 ${className}`} aria-hidden>
    <path
      d="M1 2h18M1 13h18M1 2v11M19 2v11M5 2v11M9 2v11M13 2v11M17 2v11M1 6h18M1 10h18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      opacity="0.7"
    />
  </svg>
);

export default TennisBall;
